import { useMutation, type UseMutationResult, useQueryClient } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { editChartAccount } from "../api/editChartAccount";
import type { ChartAccountData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useEditChartAccount = (): UseMutationResult<ApiResponse<null>, ApiError, ChartAccountData> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: editChartAccount,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: withPrefix(['chart_accounts']) });
		}
	})
}
